import React from 'react';

const AVATAR_COLORS = [
  'bg-red-500',
  'bg-blue-500',
  'bg-green-500',
  'bg-yellow-800',
  'bg-purple-500',
  'bg-pink-500',
  'bg-indigo-500',
  'bg-teal-500',
];

export const getInitials = (name: string): string =>
  name
    .split(' ')
    .map((w) => w[0]?.toUpperCase())
    .filter(Boolean)
    .slice(0, 2)
    .join('');

export const getAvatarBgColor = (name: string): string =>
  AVATAR_COLORS[name.charCodeAt(0) % AVATAR_COLORS.length];

interface UserAvatarProps {
  /** Full name used for initials & colour fallback */
  name: string;
  /** Profile image URL — shown when truthy */
  profileImageURL?: string | null;
  /** Extra Tailwind classes for size, border, etc.  e.g. "w-8 h-8 text-xs" */
  className?: string;
}

/**
 * Displays a user's profile picture when available,
 * otherwise falls back to coloured initials.
 */
const UserAvatar: React.FC<UserAvatarProps> = ({ name, profileImageURL, className = 'w-7 h-7 text-xs' }) => {
  const initials = getInitials(name || '?');
  const bgColor = getAvatarBgColor(name || '?');
  const [hasError, setHasError] = React.useState(false);

  if (profileImageURL && !hasError) {
    return (
      <img
        src={profileImageURL}
        alt={name}
        className={`${className} rounded-full object-cover shrink-0`}
        onError={() => setHasError(true)}
        referrerPolicy="no-referrer"
      />
    );
  }

  return (
    <div
      className={`${className} ${bgColor} rounded-full flex items-center justify-center  text-white font-medium leading-none shrink-0`}
    >
      {initials}
    </div>
  );
};

export default UserAvatar;
